module.exports = __webpack_public_path__ + "img/default_minerva.c575fb4c.jpg";